import { HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './state/scatter-plot.reducer';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { ScatterPlotPageSharedModule } from 'ChartApp/ts/features/scatter-plot-page-shared/scatter-plot-page-shared.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { CheckboxGroupModule } from 'NewAngular/features/components/inputs/checkbox-group/checkbox-group.module';
import { SimpleInputModule } from 'NewAngular/features/components/inputs/simple-input/simple-input.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ChartEmbedModalModule } from 'NewAngular/features/components/modals/chart-embed-modal/chart-embed-modal.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'NewAngular/features/components/modals/template-modal/template-modal.module';
import { UrlShortenerModalModule } from 'NewAngular/features/components/modals/url-shortener-modal/url-shortener-modal.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PageErrorMessageModule } from 'NewAngular/features/components/page-error-message/page-error-message.module';
import { OpenItemModalModule } from 'NewAngular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { SavedItemDropdownModule } from 'NewAngular/features/components/saved-items/saved-item-dropdown/saved-item-dropdown.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { ScatterPlotPageComponent } from './components/scatter-plot-page/scatter-plot-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PageToastMessagesComponent } from 'NewAngular/features/components/toast-messages/page-toast-messages.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class ScatterPlotPageModule {
}
ScatterPlotPageModule.ɵfac = function ScatterPlotPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotPageModule)(); };
ScatterPlotPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ScatterPlotPageModule, bootstrap: [ScatterPlotPageComponent, TopBarNavComponent] });
ScatterPlotPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // Jsonp module must be imported before ConfigModule to
        // prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        HttpClientJsonpModule,
        BrowserModule,
        ChartEmbedModalModule,
        ChartsSharedModule,
        CheckboxGroupModule,
        ConfigModule,
        DisabledModule,
        FeatureNeededModule,
        FoldersSharedModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        HelpModalModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        LegacyAssetConversionCheckerModule,
        LoadingSymbolModule,
        ModuleUpsellModule,
        NavigationModule,
        OpenItemModalModule,
        PageErrorMessageModule,
        RouterModule.forRoot([], { useHash: true }),
        SavedItemDropdownModule,
        ScatterPlotPageSharedModule,
        SharingModalModule,
        SideMenuModule,
        SimpleDropdownModule,
        SimpleInputModule,
        SingleSelectDropdownModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
        TemplateModalModule,
        PageToastMessagesComponent,
        TooltipModule,
        UrlShortenerModalModule] });
